<script>
export default {
  name: "DopFilter",
  props: {
    options: Object,
  },
  methods: {
    toogleActive(event) {
      event.currentTarget.classList.toggle("active");
    },
  },
};
</script>
<template>
  <div @click="toogleActive" class="dopFilter">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M3 7H21"
        stroke="#1A1A1A"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <path
        opacity="0.34"
        d="M6 12H18"
        stroke="#1A1A1A"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <path
        d="M10 17H14"
        stroke="#1A1A1A"
        stroke-width="1.5"
        stroke-linecap="round"
      />
    </svg>
    <div class="dopFilter__title">{{ options.name }}</div>
  </div>
</template>

<style scoped>
.dopFilter {
  
  display: flex;
  align-items: center;
  gap: 10px;
}
.dopFilter__title{
    color: #80879c;
  font-family: Aeroport;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-decoration-line: underline;
}
.dopFilter svg{
    transition: all 0.3s;
}
.dopFilter.active svg {
    transform: rotate(180deg);
}
</style>